import React from "react"
import { Table } from "reactstrap"
import { Link } from "react-router-dom"
import "./FormsTable.css"
import styled from "@emotion/styled"

const StyledTableContainer = styled.div`
    width: 100%;
    padding: 1em;
    overflow-x: auto; /* Allows horizontal scroll if necessary */
`

const StyledTable = styled(Table)`
    width: 100%;
    table-layout: fixed;
    background-color: transparent;
    border-radius: 16px 16px 0px 0px;
    overflow: hidden;

    & thead {
        background-color: #f8f9fa;
        // border-radius: 16px 16px 0px 0px;
    }

    // & th {
    //   padding-block: 1.5em;
    //   background-color: ##F0F0F0;
    //   text-align: left;
    //   font-size: 1rem;
    //   color: #495057;
    //   border-bottom: 2px solid #dee2e6;
    // }

    & td {
        padding: 1em;
        text-align: left;
        font-size: 14px;
        font-weight: 500;
        border: none; /* Remove all borders */
        border-bottom: 1px solid #dee2e6; /* Only keep the bottom border */
        vertical-align: middle;
        background-color: white; /* Ensure the background is white */
    }

    // & td:first-child {
    //   border-top: none; /* Ensure no top border on the first row */
    //   color: #036F36; /* Set the text color for the first column */
    // }

    & tbody {
        & tr {
            background-color: white !important; /* Ensure all rows have a white background */
            cursor: default;

            &:hover {
                background-color: #f8f9fa; /* Add a hover effect for rows */
            }

            & .description_cell {
                white-space: pre-wrap;
                word-wrap: break-word;
                text-overflow: ellipsis;
                overflow-wrap: break-word;
                max-width: 200px;
            }
        }

    }


    & tbody tr td:nth-of-type(2) {
    .name-cell {
      padding: 0.2em 0.4em;
      color: #28a745; /* Green color for the text */
      text-decoration: none; /* Prevent underline for links */
      background-color: transparent; /* Remove blue highlight */
    }

    .name-cell:hover {
      text-decoration: underline; /* Add underline on hover for better UX */
    }
  }
`;


function ETrackerTable({ forms }) {
  return (
    <StyledTableContainer>
      <StyledTable className="custom-table">
        <colgroup>
          <col style={{ width: "15%" }} />
          <col style={{ width: "25%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "20%" }} />
          <col style={{ width: "12.5%" }} />
          <col style={{ width: "12.5%" }} />
        </colgroup>
        <thead className="table-header">
        <tr>
          <th scope="col">Location</th>
          <th scope="col">Policy</th>
          <th scope="col">Stage</th>
          <th scope="col">Milestone</th>
          <th scope="col">Owner</th>
          <th scope="col">Supervisor</th>
        </tr>
        </thead>
        <tbody>
        {forms && forms.length > 0 ? (
          forms.map((row, i) => {
            const owner = row.owner_and_supervisor?.owner
                ? `${row.owner_and_supervisor.owner.first_name} ${row.owner_and_supervisor.owner.last_name}`
                : "";

              const supervisor = row.owner_and_supervisor?.supervisor
                ? `${row.owner_and_supervisor.supervisor.first_name} ${row.owner_and_supervisor.supervisor.last_name}`
                : "";

              return (
                <tr key={i}>
                    <td style={{ color: "#4D4D4D" }}>
                      {row?.country.long_name || ""}
                    </td>
                  <td className="col-w-lg">
                    <a href={`/etracker-forms/${row.policy_id}/${row.stage_id}`} rel="noopener noreferrer" className="flex items-start">
                          <span className="arrow-icon">↗</span>
                          <p className="text-green-700">{row?.policy?.name.replaceAll('_', ' ')}</p>
                    </a>
                  </td>
                  <td>{row?.stage.name || ""}</td>
                  <td>{row?.e_tracker_milestone.name || ""}</td>
                  <td>{owner}</td>
                  <td>{supervisor}</td>
                </tr>
              );
          })
        ) : (
          <tr>
            <td colSpan="7">No data available</td>
          </tr>
        )}
        </tbody>
      </StyledTable>
    </StyledTableContainer>
  );
}


export default ETrackerTable
